document.addEventListener('DOMContentLoaded', () => {
   ajaxify();
});
document.querySelectorAll('.loadmore').forEach(button => {
  button.addEventListener('click', function (e) {
    e.preventDefault();
    // code xử lý sau khi click vào nút loadmore ở đây
  });
});


function ajaxify(settings = {}) {
  const {
    linkParent = '.pagination',
    parentContainer = '#MainContent',
    endlessScrollContainer = '.EndlessScroll',
    endlessClickContainer = '.EndlessClick',
    endlessOffset = 0,
    ajaxinateContainer = '.Ajaxinate',
    ajaxinateLink = '.page a',
    fade = 300,
    textChange = 'Loading'
  } = settings;

  let linkElem, contentContainer, pageNumber, pageType, moreURL;

  async function loadMore() {
    if (!moreURL) return;

    try {
      const res = await fetch(moreURL);
      const text = await res.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(text, 'text/html');
      const newContent = doc.querySelector(contentContainer)?.innerHTML;

      if (!newContent) return;

      // Xử lý phân trang ajax
      if (pageType === 'ajax') {
        document.querySelectorAll(`${ajaxinateContainer}:not([data-page="${pageNumber}"])`).forEach(el => el.style.display = 'none');
        history.pushState({}, pageNumber, moreURL);
      } else {
        const link = document.querySelector(linkElem);
        link?.parentElement?.parentElement?.remove();
      }

      const container = document.querySelector(contentContainer);
      
      if (container) {
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = newContent;
        const newNodes = Array.from(tempDiv.children);
        newNodes.forEach(node => {
          node.style.opacity = '0';
          container.appendChild(node);
          setTimeout(() => { node.style.transition = `opacity ${fade}ms`; node.style.opacity = '1'; }, 10);
        });
      }

      // Re-init sau khi load
      if (pageType === 'endlessScroll') endlessScroll();
      else if (pageType === 'ajax') ajaxinationClick();
      else if (pageType === 'endlessClick') endlessClick();

      initCountd();
      initButtonsWishlist();
      initButtonsCompare();
      
      handleReinitFunctions();
    } catch (err) {
      console.error('Ajax load failed:', err);
    }
  }

  function endlessScroll() {
    const action = ['scroll', 'resize'];
    function onScroll() {
      contentContainer = endlessScrollContainer;
      const lastLink = document.querySelector(`${contentContainer}:last-of-type ${linkElem}`);
      if (!lastLink) return;

      moreURL = lastLink.href;
      pageType = 'endlessScroll';
      lastLink.textContent = textChange;

      const bottom = document.querySelector(parentContainer)?.offsetHeight || 0;
      const docTop = window.scrollY + window.innerHeight + endlessOffset;

      if (docTop > bottom) {
        action.forEach(a => window.removeEventListener(a, onScroll));
        loadMore();
      }
    }
    action.forEach(a => window.addEventListener(a, onScroll));
  }

  function endlessClick() {
    document.querySelectorAll(linkElem).forEach(link => {
      link.addEventListener('click', e => {
        e.preventDefault();
        contentContainer = endlessClickContainer;
        moreURL = link.href;
        pageType = 'endlessClick';
        link.textContent = textChange;
        loadMore();
      });
    });
  }

  function ajaxinationClick() {
    document.querySelectorAll(linkElem).forEach(link => {
      link.addEventListener('click', e => {
        e.preventDefault();
        contentContainer = ajaxinateContainer;
        moreURL = link.href;
        pageNumber = link.dataset.number;
        pageType = 'ajax';

        const targetPage = document.querySelector(`${contentContainer}[data-page="${pageNumber}"]`);
        if (targetPage) {
          document.querySelectorAll(contentContainer).forEach(c => c.style.display = 'none');
          targetPage.style.display = 'block';
          history.pushState({}, pageNumber, moreURL);
        } else {
          loadMore();
        }

        window.scrollTo({ top: document.querySelector(parentContainer).offsetTop, behavior: 'smooth' });
      });
    });
  }

  // Gọi lại mấy hàm JS khác sau khi load thêm content
  function handleReinitFunctions() {
    // ví dụ tái kích hoạt gallery hover
    document.querySelectorAll('.product-card__gallery .item-img').forEach(el => {
      el.addEventListener('mouseover', () => {
        el.classList.add('thumb-active');
        el.parentElement.querySelectorAll('.item-img').forEach(sib => {
          if (sib !== el) sib.classList.remove('thumb-active');
        });
        const thumbSrc = el.dataset.src;
        const img = el.closest('.product-item-container')?.querySelector('.img-responsive.s-img');
        if (img && thumbSrc) img.src = thumbSrc;
      });
    });

    // sticky header
    window.addEventListener('scroll', () => {
      document.querySelector('.header.header-fixed')?.classList.toggle('stickytop', window.scrollY >= 36);
    });
  }

  // Khởi tạo loại phân trang
  if (document.querySelector(endlessClickContainer)) {
    linkElem = `${linkParent} a`;
    endlessClick();
  }

  if (document.querySelector(ajaxinateContainer)) {
    linkElem = ajaxinateLink;
    ajaxinationClick();
  }

  if (document.querySelector(endlessScrollContainer)) {
    linkElem = `${linkParent} a`;
    endlessScroll();
  }
}
